import type { ChangeWorkGroup } from '../../types/changes';

export function internalTemplateOwnerId(slot: ChangeWorkGroup): number | null {
  const tpl = slot.internal_templates?.[0];
  const raw = tpl?.owner_user_id;
  return typeof raw === 'number' && raw > 0 ? raw : null;
}

export function isPersonalInternalSlot(slot: ChangeWorkGroup): boolean {
  return internalTemplateOwnerId(slot) !== null;
}

/** Editar/remover linha do pacote: globais só gestor; pessoais só o dono; manual (sem modelo) conforme política. */
export function canMutateInternalPackageSlot(
  slot: ChangeWorkGroup,
  opts: {
    currentUserId?: number;
    isChangeManager: boolean;
    allowRequesterPackageEdit?: boolean;
  },
): boolean {
  const ownerId = internalTemplateOwnerId(slot);
  if (ownerId !== null) {
    return Boolean(opts.currentUserId && opts.currentUserId === ownerId);
  }
  const templateId = slot.internal_subtask_template_id;
  if (!templateId) {
    return opts.isChangeManager || Boolean(opts.allowRequesterPackageEdit);
  }
  return opts.isChangeManager;
}
